import { Action } from '@ngrx/store';


export enum ETasksActions {
    GetTasks = '[Tasks] Get Tasks',
    GetTasksDetails = '[Tasks] Set Tasks Details',
    AddTasks = '[Tasks] Add Tasks',
    // EditTasks = '[Tasks] Edit Tasks',
    SetTasksSuccess = 'Set Tasks Success',
    SetTasksError = 'Set Tasks Error',
    AddTaskForSubUser = '[Tasks] Add Task For SubUser',
    GetAddTaskForSubUserSuccess = '[Tasks] Get Add Task For SubUser Success',
    GetAddTaskForSubUserError = '[Tasks] Get Add Task For SubUser Error',

}

export class GetTasks implements Action {
    public readonly type = ETasksActions.GetTasks;
    constructor(public payload: any) {}
}

export class GetTasksDetails implements Action {
    public readonly type = ETasksActions.GetTasksDetails;
    constructor(public payload: any) {
      
    }
}

export class AddTasks implements Action {
    public readonly type = ETasksActions.AddTasks;
    constructor(public payload: any) {
    }
}

export class SetTasksSuccess implements Action {
    public readonly type = ETasksActions.SetTasksSuccess;
    constructor(public payload: any, public from: any) {
    }
}

export class SetTasksError implements Action {
    public readonly type = ETasksActions.SetTasksError;
    constructor(public payload: any, public from: any) {
    }
}
export class AddTaskForSubUser implements Action {
    public readonly type = ETasksActions.AddTaskForSubUser;
    constructor(public payload: any) {
    }
}
export class GetAddTaskForSubUserSuccess implements Action {
    public readonly type = ETasksActions.GetAddTaskForSubUserSuccess;
    constructor(public payload: any) {
    }
}
export class GetAddTaskForSubUserError implements Action {
    public readonly type = ETasksActions.GetAddTaskForSubUserError;
    constructor(public payload: any) {
    }
}




export type TasksAction =  GetTasks | GetTasksDetails | SetTasksSuccess | SetTasksError | AddTasks|
                            AddTaskForSubUser| GetAddTaskForSubUserSuccess| GetAddTaskForSubUserError;